// src/pages/StudentPlayPage.jsx
import React, { useEffect, useState } from "react";
import { liveSocket } from "../lib/liveSocket";

export default function StudentPlayPage() {
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [joined, setJoined] = useState(false);

  const [session, setSession] = useState(null);
  const [answering, setAnswering] = useState(false);
  const [statusText, setStatusText] = useState("");

  useEffect(() => {
    liveSocket.connect();

    liveSocket.on("live:state", (state) => {
      setSession(state);
    });

    return () => {
      liveSocket.off("live:state");
      liveSocket.disconnect();
    };
  }, []);

  const handleJoin = () => {
    if (!code || !name) return;
    setStatusText("Sessiyaga ulanmoqda...");

    liveSocket.emit("student:join", { code, name }, (res) => {
      if (!res?.ok) {
        setStatusText(res?.error || "Xatolik yuz berdi");
      } else {
        setSession(res.state);
        setJoined(true);
        setStatusText("");
      }
    });
  };

  const handleAnswer = (optionIndex) => {
    if (!session) return;
    setAnswering(true);

    liveSocket.emit(
      "student:answer",
      { sessionId: session.sessionId, optionIndex },
      (res) => {
        if (!res?.ok) {
          setStatusText(res?.error || "Javob yuborilmadi");
        }
        setAnswering(false);
      }
    );
  };

  const isLobby = session?.status === "LOBBY";
  const isRunning = session?.status === "RUNNING";
  const isFinished = session?.status === "FINISHED";

  const currentPlayer =
    session &&
    session.participants?.find(
      (p) => p.positionInQueue === session.currentPlayerIndex
    );

  const itsMyTurn = currentPlayer?.name === name;

  // 1) Kirish formasi
  if (!joined) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 w-full max-w-md space-y-4">
          <h1 className="text-lg font-semibold text-center">
            Jonli testga qo‘shilish
          </h1>

          <div>
            <label className="block text-xs text-gray-500 mb-1">
              Kirish kodi
            </label>
            <input
              className="w-full border border-gray-200 rounded-xl px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-black"
              value={code}
              onChange={(e) => setCode(e.target.value)}
            />
          </div>

          <div>
            <label className="block text-xs text-gray-500 mb-1">
              Ismingiz
            </label>
            <input
              className="w-full border border-gray-200 rounded-xl px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-black"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <button
            onClick={handleJoin}
            className="w-full bg-black text-white rounded-full py-2 text-sm"
          >
            Qo‘shilish
          </button>

          {statusText && (
            <p className="text-xs text-red-500 text-center">{statusText}</p>
          )}
        </div>
      </div>
    );
  }

  // 2) Ichki holat
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 w-full max-w-xl space-y-5">
        <div className="flex items-center justify-between text-xs text-gray-500">
          <div>
            <p className="uppercase tracking-wide">Kirish kodi</p>
            <p className="text-sm font-semibold">{session?.code}</p>
          </div>
          <div className="text-right">
            <p className="uppercase tracking-wide">Ism</p>
            <p className="text-sm font-semibold">{name}</p>
          </div>
        </div>

        {isLobby && (
          <div className="text-center text-sm text-gray-600 py-6">
            O‘qituvchi testni boshlashini kutyapmiz...
          </div>
        )}

        {isRunning && (
          <>
            {!itsMyTurn && (
              <div className="text-center text-sm text-gray-600">
                Hozir navbat:{" "}
                <span className="font-semibold">
                  {currentPlayer ? currentPlayer.name : "noma’lum"}
                </span>
              </div>
            )}

            {itsMyTurn && session.question && (
              <div className="space-y-3">
                <p className="text-xs text-gray-500">
                  Savol{" "}
                  <span className="font-semibold">
                    {session.currentQuestionIndex + 1}
                  </span>
                </p>

                <p className="text-sm font-semibold text-gray-900">
                  {session.question.text}
                </p>

                <div className="space-y-2">
                  {session.question.options.map((opt, idx) => (
                    <button
                      key={idx}
                      onClick={() => handleAnswer(idx)}
                      disabled={answering}
                      className="w-full text-left px-3 py-2 rounded-lg border border-gray-200 text-sm hover:bg-gray-50 disabled:opacity-60"
                    >
                      <span className="mr-2 text-xs font-semibold text-gray-400">
                        {String.fromCharCode(65 + idx)}
                      </span>
                      {opt}
                    </button>
                  ))}
                </div>

                {statusText && (
                  <p className="text-xs text-red-500">{statusText}</p>
                )}
              </div>
            )}
          </>
        )}

        {isFinished && (
          <div className="space-y-3">
            <p className="text-sm font-semibold">Test tugadi 🎉</p>
            <p className="text-xs text-gray-500">
              Quyida umumiy natijalar ro‘yxatini ko‘rishingiz mumkin.
            </p>

            <div className="mt-2 text-xs text-gray-700 space-y-1">
              {session?.participants?.map((p) => (
                <div
                  key={p.name}
                  className={`flex justify-between ${
                    p.name === name ? "font-semibold" : ""
                  }`}
                >
                  <span>{p.name}</span>
                  <span>{p.score} ball</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
